var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theme-transition",
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "theme-tranistion",
    clipPath: "url(#clip0_1_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.015 95.724C106.568 103.356 106.568 115.73 99.015 123.362C91.4624 130.994 79.2171 130.994 71.6645 123.362C64.1118 115.73 64.1118 103.356 71.6645 95.724C79.2171 88.092 91.4624 88.092 99.015 95.724ZM180.336 95.724C187.888 103.356 187.888 115.73 180.336 123.362C172.783 130.994 160.537 130.994 152.985 123.362C145.432 115.73 145.432 103.356 152.985 95.724C160.537 88.092 172.783 88.092 180.336 95.724ZM69.1641 132.129C70.8974 161.086 94.0249 184.263 122.93 186C121.197 157.043 98.0693 133.866 69.1641 132.129ZM129.765 186C131.483 157.043 154.415 133.866 183.075 132.129C181.357 161.086 158.425 184.263 129.765 186Z",
    fill: "var(--s_m_font_color)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 125.5,
    r: 124,
    stroke: "#757572",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/CRM.8184838b7e4538396077429567065024.svg";
export { ForwardRef as ReactComponent };